import type React from 'react'

type Props = {
  size?: number
}

const IconSymbolLibrary: React.FC<Props> = ({ size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3359 2.99119L3.39924 9.99927L10.3359 17.0073L17.2726 9.99927L10.3359 2.99119ZM11.2763 1.38395C10.7686 0.87104 9.90328 0.871041 9.3956 1.38395L1.67882 9.18013C1.22164 9.64201 1.22164 10.3565 1.67882 10.8184L9.3956 18.6146C9.90328 19.1275 10.7686 19.1275 11.2763 18.6146L18.9931 10.8184C19.4502 10.3565 19.4502 9.64201 18.9931 9.18013L11.2763 1.38395Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5994 14.45L5.88516 6.73576L7.07243 5.54849L14.7867 13.2628L13.5994 14.45Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5994 5.54849L5.24231 13.9056L6.42957 15.0929L14.7867 6.73576L13.5994 5.54849Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconSymbolLibrary
